import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Chart, ChartOptions, Plugin } from 'chart.js';
import { Subscription } from 'rxjs';
import { ThemeService } from './theme.service';
import { applyThemeColorsToChart, chartOptionsFromCss } from './test';

@Injectable({ providedIn: 'root' })
export class ChartThemeService implements OnDestroy {
  private sub: Subscription;

  constructor(theme: ThemeService) {
    this.sub = theme.darkMode$.subscribe(() => {
      Chart.defaults.set(chartOptionsFromCss());
      for (const chart of Object.values(Chart.instances)) {
        applyThemeColorsToChart(chart);
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }


}

